import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface InternalLinkingOptimizerProps {
  currentPage: string;
  className?: string;
}

const InternalLinkingOptimizer = ({ currentPage, className = "" }: InternalLinkingOptimizerProps) => {
  const getRelatedLinks = (page: string) => {
    switch (page) {
      case 'professional-network':
        return [
          { title: 'For Caregivers', url: '/family-caregiver-tools', description: 'Professional caregiver tools and resources' },
          { title: 'Pricing Plans', url: '/pricing', description: 'Professional and family pricing options' },
          { title: 'About SeniorThrive', url: '/about-seniorthrive', description: 'Learn about our mission and vision' },
          { title: 'Blog', url: '/blog', description: 'Expert advice and industry insights' }
        ];
      case 'home':
        return [
          { title: 'For Older Adults', url: '/older-adults', description: 'Independence and safety tools' },
          { title: 'For Families', url: '/thrivefamily', description: 'Family coordination and peace of mind' },
          { title: 'Professional Network', url: '/professional-network', description: 'Join our care professional community' },
          { title: 'Features', url: '/features', description: 'Comprehensive platform capabilities' }
        ];
      case 'blog':
        return [
          { title: 'Get VIP Access', url: '/get-vip', description: 'Early access to new features' },
          { title: 'Community Resources', url: '/features', description: 'Tools for healthy aging' },
          { title: 'Safety Solutions', url: '/older-adults', description: 'Home safety and fall prevention' }
        ];
      default:
        return [
          { title: 'Home', url: '/', description: 'SeniorThrive platform overview' },
          { title: 'Features', url: '/features', description: 'Platform tools and capabilities' },
          { title: 'Pricing', url: '/pricing', description: 'Plans for individuals and families' }
        ];
    }
  };

  const links = getRelatedLinks(currentPage);

  return (
    <Card className={`bg-muted/30 border-primary/20 ${className}`}>
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <HomeIcon className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Explore More</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.url}
              className="flex items-start gap-3 p-3 rounded-lg hover:bg-background/50 transition-colors group"
            >
              <ArrowRightIcon className="h-4 w-4 text-primary mt-1 group-hover:translate-x-1 transition-transform" />
              <div className="flex-1">
                <div className="font-medium text-foreground group-hover:text-primary transition-colors">
                  {link.title}
                </div>
                <div className="text-sm text-muted-foreground">
                  {link.description}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default InternalLinkingOptimizer;